<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <div class="form-group">
            <h3 class="card-title">Novo Atendimento</h3>
          </div>

          <!-- <div class="form-group">
                            <label for="inputField" class="col-form-label">Latitude:</label>
                            <div class="custom-input-container">
                                <input type="text" style="background-color: #efefef ;" v-model="geo.latitude" class="custom-input" :disabled="isDisabled"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="inputField" class="col-form-label">Longitude:</label>
                            <div class="custom-input-container">
                                <input type="text" style="background-color: #efefef ;" v-model="geo.longitude" class="custom-input" :disabled="isDisabled"/>
                            </div>
                        </div> -->

          <!-- <h3 class="card-title" style="text-align: center;">Solicitar Atendimento</h3> -->
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Solicitante: </label>
              <h5 style="font-weight: lighter" class="card-title">
                {{ usuario_nome }}
              </h5>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Paciente: </label>
              <input
                type="text"
                v-model="ocorrencia.paciente_solicitado"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Documento: </label>
              <input
                type="text"
                v-model="ocorrencia.documento"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> CEP: </label>
              <input
                type="text"
                v-model="ocorrencia.cep"
                class="custom-input"
                v-on:keyup="buscar"
                v-mask="'99999-999'"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Logradouro: </label>
              <input
                type="text"
                v-model="ocorrencia.logradouro"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Número: </label>
              <input
                type="text"
                v-model="ocorrencia.numero"
                class="custom-input"
                id="inputNumero"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Bairro: </label>
              <input
                type="text"
                v-model="ocorrencia.bairro"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Complemento: </label>
              <input
                type="text"
                v-model="ocorrencia.complemento"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Cidade: </label>
              <input
                type="text"
                v-model="ocorrencia.cidade"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <label style="font-weight: bold"> Estado: </label>
              <input type="text" v-model="ocorrencia.uf" class="custom-input" />
            </div>
          </div>
          <div class="form-group">
            <label
              for="inputField"
              style="font-weight: bold"
              class="col-form-label"
              >Queixa Principal:</label
            >
            <div class="custom-input-container">
              <textarea
                v-model="ocorrencia.queixa_principal"
                style="height: 83px"
                maxlength="260"
                class="custom-input"
              />
            </div>
          </div>
          <br />
          <div class="form-group">
            <GmapMap
              v-if="
                ocorrencia.latitude !== 0 &&
                ocorrencia.longitude !== 0 &&
                position.lat !== 0 &&
                position.lng !== 0
              "
              :center="{ lat: ocorrencia.latitude, lng: ocorrencia.longitude }"
              :options="{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
              }"
              :zoom="16"
              map-type-id="roadmap"
              style="width: auto; height: 250px; border-radius: 50px !important"
            >
              <GmapMarker
                v-if="
                  ocorrencia.latitude !== 0 &&
                  ocorrencia.longitude !== 0 &&
                  position.lat !== 0 &&
                  position.lng !== 0
                "
                :position="position"
              ></GmapMarker>
            </GmapMap>
            <!-- <GmapMarker :marker="{ lat: geo.latitude, lng: geo.longitude }"></GmapMarker> -->
            <!-- <span style="text-align: center !important;">Sua localização: Lat {{ocorrencia.latitude}} Lon {{ocorrencia.longitude}}</span> -->
          </div>
          <div class="form-group botao-solicitar">
            <div class="col-md-12">
              <button @click="criarOcorrencia()" type="button" class="btn">
                SOLICITAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
/* import GmapMap from 'vue2-google-maps'; */
export default {
  data() {
    return {
      position: {
        lat: 0,
        lng: 0,
      },
      ocorrencia: {
        latitude: 0,
        longitude: 0,
        queixa_principal: "",
        ip_solicitante: "",
        paciente_id: 0,
        usuario_solicitante_id: 0,
        status: 0,
      },
      isDisabled: true,
      isLoading: false,
      loadingColor: "#5D9CEC",
      pacientes: "",
      usuario_id: {
        usuario_id: "",
      },
      usuario_nome: "",
    };
  },
  computed: {},
  methods: {
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.ocorrencia.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.ocorrencia.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.ocorrencia.logradouro = self.endereco.logradouro;
            self.ocorrencia.bairro = self.endereco.bairro;
            self.ocorrencia.cidade = self.endereco.localidade;
            self.ocorrencia.uf = self.endereco.uf;
            $("#inputNumero").focus();
          }
        );
      }
    },
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    criarOcorrencia() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "ocorrencia";

      axios
        .post(api, self.ocorrencia)
        .then((response) => {
          console.log("RESPOSTA ATENDIMENTO: " + response.data);
          self.$message("Sucesso", `Atendimento criado com sucesso`, "success");
          self.isLoading = false;
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getPacientes(id) {
      const self = this;
      self.isLoading = true;

      this.usuario_id.usuarioid = id;

      const api = self.$store.state.api + "pacientes/usuario_id/" + id;
      axios
        .get(api, this.usuario_id)
        .then((response) => {
          if (response.data == "") {
            self.$message(
              "Erro",
              `Você ainda não cadastrou um paciente.`,
              "error"
            );
            this.$router.push("/pacientes");
          }
          self.pacientes = response.data;
          console.log("TERMINEI NORMAL");
          /* self.isLoading = false */
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          console.log("TERMINEI FINALLY");
          self.isLoading = false;
        });
    },
    getIPAddress() {
      const self = this;
      return fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          self.ocorrencia.ip_solicitante = data.ip; // Returns the IP address object
        });
    },
    getGeo() {
      const self = this;
      self.isLoading = true;

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.ocorrencia.latitude = position.coords.latitude;
          this.ocorrencia.longitude = position.coords.longitude;

          this.position.lat = position.coords.latitude;
          this.position.lng = position.coords.longitude;
        });
      } else {
        console.log("Geolocalização não é suportada pelo seu navegador");
      }
    },
  },
  components: {
    Loading,
    vSelect,
  },
  props: {},
  mounted: function () {
    const self = this;
    self.isLoading = true;

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    self
      .getIPAddress()
      .then((ipAddress) => {
        this.ocorrencia.ip = ipAddress; // Print the user's IP address
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    self.getGeo();

    var id = localStorage.getItem("usuario_id");
    this.ocorrencia.usuario_solicitante_id = Number(id);

    var usr_nome = localStorage.getItem("usuario_nome");
    this.usuario_nome = usr_nome;

    self.getPacientes(id);
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  /* box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15); */
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.vue-map-container .vue-map .gm-style {
  border-radius: 30px !important;
}

.botao-solicitar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}
</style>


// WEBPACK FOOTER //
// src/components/SolicitarAtendimentoFavorito.vue